import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        primary: '#667dff',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#58D68D',
        warning: '#FFC107',
        blue: '#667dff',
        gray: '#303956',
        green: '#58D68D',
        themes: {
            light: {
              primary: '#3f51b5',
              green: '#5F9EA0',
              red: '#F15F79',
              orange: '#E97451',
              blue:'#6495ED',
              purple:'#9d50bb',
              gray:'#cccccc',
              gray_dk:'#949494',
              secondary: '#b0bec5',
              accent: '#8c9eff',
              error: '#b71c1c',
            },
          },
    },
});
